module.exports = __webpack_public_path__ + "static/media/Arrow_Up_dark.91d53ed1.svg";